import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f7b70cd0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=f7b70cd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b70cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-airdrop-manager-fe/treasurenet-tnservices-airdrop-manager-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7b70cd0')) {
      api.createRecord('f7b70cd0', component.options)
    } else {
      api.reload('f7b70cd0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=f7b70cd0&scoped=true", function () {
      api.rerender('f7b70cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/airdropPlan/detail.vue"
export default component.exports